import styled, { keyframes } from 'styled-components';
import theme from '../styles/theme';

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
`;

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: absolute;
  inset: 0;
  width: 100%;
  background: rgba(241, 245, 249, 0.85);
  backdrop-filter: blur(4px);
  z-index: 50;
`;

const Dots = styled.div`
  display: flex;
  gap: 8px;
  padding: 20px 28px;
  background: ${theme.colors.card};
  border-radius: ${theme.radius.pill};
  box-shadow: ${theme.shadows.lg};
  border: 1px solid ${theme.colors.cardBorder};
`;

const Dot = styled.div`
  width: 10px;
  height: 10px;
  background: ${theme.colors.accentGradient};
  border-radius: 50%;
  animation: ${bounce} 1.2s infinite ease-in-out both;

  &:nth-child(1) {
    animation-delay: -0.24s;
  }
  &:nth-child(2) {
    animation-delay: -0.12s;
  }
`;

const Loader = () => (
  <LoaderWrapper>
    <Dots>
      <Dot />
      <Dot />
      <Dot />
    </Dots>
  </LoaderWrapper>
);

export default Loader;
